import {inject} from '~ui/store/store';

import {reducer, UserSettingsState} from './slice';

const KEY = 'userSettings';

inject(KEY, reducer);

declare global {
    interface WikiState {
        [KEY]: UserSettingsState;
    }
}
